import React from "react";
import meta from "../versionMeta.generated.json";

/**
 * Header version chip: shows v1.2.3; hover title = release timestamp + commit.
 */
export default function AppVersionBadge(props) {
  var style = props && props.style ? props.style : {};
  var rest = {};
  if (props) {
    Object.keys(props).forEach(function (k) {
      if (k !== "style") rest[k] = props[k];
    });
  }
  var v = meta && meta.version ? meta.version : "?";
  var tip = "";
  if (meta && meta.releasedAt) {
    try {
      tip = "Released " + new Date(meta.releasedAt).toLocaleString();
    } catch (e) {
      tip = "Released " + String(meta.releasedAt);
    }
    if (meta.commit) tip += " · " + meta.commit;
  } else {
    tip = "Build version";
  }
  return (
    <span
      title={tip}
      style={Object.assign(
        {
          fontSize: "0.65rem",
          color: "#64748b",
          flexShrink: 0,
          cursor: "help",
          userSelect: "none",
        },
        style
      )}
      {...rest}
    >
      v{v}
    </span>
  );
}
